import Accordion, { AccordionProps } from 'components/elements/Accordion/Accordion'
import React from 'react'
import styles from './AccordionGroup.module.scss'
import { Heading } from '~elements'
import { Container } from 'react-grid-system'
import { useWindowSize } from 'utils/hooks'

interface AccordionGroupProps {
  headline?: string
  accordions: AccordionProps[]
}

const AccordionGroup = ({ headline, accordions }: AccordionGroupProps) => {
  const { isBreakpoint: isBelowBreakpointSm } = useWindowSize('xs', '<')
  if (!accordions || !Array.isArray(accordions)) return null

  return (
    <>
      <div className={styles['accordion-group']}>
        <Container className='container container--narrow-xxl'>
          {headline && (
            <Heading justify={isBelowBreakpointSm ? 'center' : 'left'} level={2}>
              <>{headline}</>
            </Heading>
          )}
          <div className={styles['accordion-group-content']}>
            {accordions.map((accordion, index) => (
              <Accordion key={index} title={accordion.title} description={accordion.description} />
            ))}
          </div>
        </Container>
      </div>
    </>
  )
}

export default AccordionGroup
